module.exports = __webpack_public_path__ + "static/media/paypal.5f7f7c15.png";